export * from './Wrap';
export * from './Path';
export * from './Actions';
export * from './background';
export * from './slide';
export * from './fade';
export * from './zoom';
export * from './bounce';
export * from './flip';
export * from './scale';
export * from './rotate';

export const varTranHover = (props) => {
    const duration = props?.duration || 0.32;
    const ease = props?.ease || [0.43, 0.13, 0.23, 0.96];
  
    return { duration, ease };
  };